import { ReactElement } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { DealmakerCard as DealmakerCardModel } from "../../../Services/DealmakerCatalog";
import { firmProfilePath, highlightedText, logoUrl } from "../dealmakerDisplay";

interface DealmakerCardProps {
  card: DealmakerCardModel;
  archived?: boolean;
}

export default function DealmakerCard({ card, archived = false }: DealmakerCardProps): ReactElement {
  const [params] = useSearchParams();
  const words = params.get("words") || "";
  const overview = `/dealmaker?view=1&action=view&dealid=${card.dealId}&firm=${card.firmId}`;
  return (
    <article className={archived ? "dealmaker-card dealmaker-card-archived" : "dealmaker-card"}>
      <div className="dealmaker-card-grid">
        <a href={firmProfilePath(card.companyType, card.companyNameSlug, card.firmId)}>
          {card.logoName ? <img className="dealmaker-logo" src={logoUrl(card.logoName)} alt="firmlogo" /> : null}
        </a>
        <div>
          <div className="text-right">
            <Link className="dealmaker-overview-link" to={overview}>Overview</Link>
          </div>
          <h3 className="dealmaker-title">
            <Link to={overview}>{highlightedText(card.title, words)}</Link>
          </h3>
          <p className="dealmaker-meta">
            {highlightedText(card.companyName, words)} | {highlightedText(card.placeLabel, words)} | {card.dateLabel}
          </p>
          <p>{highlightedText(card.excerpt, words)}</p>
        </div>
      </div>
    </article>
  );
}
